{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "Vybratých {conversationCount} konverzácií",
    "AGENT_SELECT_LABEL": "Vybrať agenta",
    "ASSIGN_CONFIRMATION_LABEL": "Naozaj chcete priradiť {conversationCount} {conversationLabel} používateľovi",
    "UNASSIGN_CONFIRMATION_LABEL": "Naozaj chcete zrušiť priradenie {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Späť",
    "ASSIGN_LABEL": "Priradiť",
    "YES": "Áno",
    "SEARCH_INPUT_PLACEHOLDER": "Hľadať",
    "ASSIGN_AGENT_TOOLTIP": "Priradiť agenta",
    "ASSIGN_TEAM_TOOLTIP": "Priradiť tím",
    "ASSIGN_SUCCESFUL": "Konverzácie boli úspešne priradené.",
    "ASSIGN_FAILED": "Nepodarilo sa priradiť konverzácie. Skúste to prosím znova.",
    "RESOLVE_SUCCESFUL": "Konverzácie boli úspešne vyriešené.",
    "RESOLVE_FAILED": "Nepodarilo sa vyriešiť konverzácie. Skúste to prosím znova.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Sú vybrané iba konverzácie viditeľné na tejto stránke.",
    "AGENT_LIST_LOADING": "Načítavajú sa agenti",
    "UPDATE": {
      "CHANGE_STATUS": "Zmeniť stav",
      "SNOOZE_UNTIL": "Odložiť",
      "UPDATE_SUCCESFUL": "Stav konverzácie bol úspešne aktualizovaný.",
      "UPDATE_FAILED": "Nepodarilo sa aktualizovať konverzácie. Skúste to prosím znova."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Priradiť štítky",
      "NO_LABELS_FOUND": "Nenašli sa žiadne štítky pre",
      "ASSIGN_SELECTED_LABELS": "Priradiť vybrané štítky",
      "ASSIGN_SUCCESFUL": "Štítky boli úspešne priradené.",
      "ASSIGN_FAILED": "Nepodarilo sa priradiť štítky. Skúste to prosím znova."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Vybrať tím",
      "NONE": "Žiadne",
      "NO_TEAMS_AVAILABLE": "K tomuto účtu zatiaľ nie sú pridané žiadne tímy.",
      "ASSIGN_SELECTED_TEAMS": "Priradiť vybraný tím.",
      "ASSIGN_SUCCESFUL": "Tímy boli úspešne priradené.",
      "ASSIGN_FAILED": "Nepodarilo sa priradiť tím. Skúste to prosím znova."
    },
    "MERGE": {
      "TOOLTIP": "Zlúčiť konverzácie",
      "TITLE": "Zlúčiť konverzácie",
      "DESCRIPTION": "Vyberte cieľovú konverzáciu. Všetky ostatné vybrané konverzácie budú do nej zlúčené — ich správy budú presunuté do cieľovej a zdrojové konverzácie budú vymazané.",
      "TARGET_LABEL": "Cieľová konverzácia (bude zachovaná)",
      "SOURCES_LABEL": "Zdrojové konverzácie (budú vymazané)",
      "SELECT_TARGET": "Vyberte konverzáciu ako cieľ zlúčenia",
      "WARNING": "Varovanie: Túto akciu nie je možné vrátiť späť. Správy zo všetkých zdrojových konverzácií budú presunuté do cieľovej konverzácie a zdrojové konverzácie budú trvalo vymazané.",
      "SUBMIT": "Zlúčiť konverzácie",
      "CANCEL": "Zrušiť",
      "SUCCESS_MESSAGE": "Konverzácie boli úspešne zlúčené",
      "ERROR_MESSAGE": "Nepodarilo sa zlúčiť konverzácie. Skúste to prosím znova.",
      "CONFIRM": {
        "TITLE": "Potvrdiť zlúčenie",
        "DESCRIPTION": "Naozaj chcete zlúčiť {sourceCount} konverzácií do #{targetId}? Túto akciu nie je možné vrátiť späť.",
        "YES": "Áno, zlúčiť",
        "CANCEL": "Zrušiť"
      }
    }
  }
}
